import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import lessRequire from '../../config/less-require-resolver';
lessRequire('modules/smart-notification/main.less');
import renderViewsState from '../shared/render-views-state';

import { enum as types } from '../../../../enums/smart-notification-types';

import { actions, selectors } from './';

const Main = renderViewsState(props => {
	const { intl, data, activateSplit, closePopup } = props;
	if (!data || !data.event) {
		return null;
	}

	return (
		<div className="smart-notification">
			<span className="close-popup" onClick={e => closePopup()}>&times;</span>
			{buildNotificationContent(data, activateSplit, closePopup, intl)}
		</div>
	) || null;
});

const NewLanding = ({newsEntry, offer, event, intl, activateSplit, closePopup}) => {
	return <div>
		<h3>
			<span dangerouslySetInnerHTML={{__html:
				intl(
					'К офферу %s добавлены новые промо',
					`<a href="offers/${offer.id}/" target="_blank">${offer.title}</a>`
				)
			}}/>
		</h3>
		<div className="message" dangerouslySetInnerHTML={{__html: newsEntry.text}}/>
		<div className="actions">
			<span className="button yellow-btn split-action"
				onClick={e => activateSplit(event.id, event.metadata.offer_id, event.metadata.domains)}
				title={intl('На всех ваших компаниях по этому офферу активируется сплит-тест с использованием нового промо')}
			>
				{intl('Включить сплит-тест на моих потоках')}
			</span>
		</div>
	</div>;
};

function buildNotificationContent (data, activateSplit, closePopup, intl) {
	switch (data.event.type) {
		case types.new_landing:
			return <NewLanding
				{...data.metadata} event={data.event} activateSplit={activateSplit} closePopup={closePopup} intl={intl}
			/>;
		default:
			return null;
	}
}

NewLanding.propTypes = {
	offer: PropTypes.object,
	newsEntry: PropTypes.object,
	event: PropTypes.object,
	activateSplit: PropTypes.func,
	closePopup: PropTypes.func,
	intl: PropTypes.func
};

export default connect(
	state => ({
		data: selectors.getData(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/smart-notification/main.js